/*
 * Copyright 2021-2022 Objectiv B.V.
 */

/**
 * Tracker platforms
 */
export enum TrackerPlatform {
  ANGULAR = 'ANGULAR',
  CORE = 'CORE',
  BROWSER = 'BROWSER',
  REACT = 'REACT',
  REACT_NATIVE = 'REACT_NATIVE',
}
